import { produce } from 'immer';

import * as Types from './types';
import { actionTypes } from './constants';

export const defaultState: Types.ILoyaltyPointsState = {
    loyaltyPoints: {}
};

export const reducer = produce((draftState, action: Types.IUpdateLoyaltyPointsAction): Types.ILoyaltyPointsState | void => {
    switch (action.type) {
        case actionTypes.UPDATE_LOYALTY_POINTS: {
            draftState.loyaltyPoints = action.payload;

            break;
        }

        default: {
            break;
        }
    }
}, defaultState);
